<app-lex-xi-side-panel
  [isLoading]="isLoading"
  [selectedItem]="selectedRoute"
  [rightPlaceholder]="routesRightPlaceholder"
  [verticalTabBarData]="[
    {
      id: 'ab_testing',
      icon: 'ab_testing',
      hasSeparator: true,
      leftSideTemplate: leftSide,
      rightSideTemplate: rightSide,
    },
  ]"
></app-lex-xi-side-panel>

<ng-template #leftSide>
  <div
    *transloco="let t; read: 'configuration-routes.list'"
    side="left"
    class="configuration-route-list__list-wrapper"
  >
    <div class="configuration-route-list__action-list-container">
      <div class="configuration-route-list__list-header">
        <h3 class="configuration-route-list__list-label">{{ t('title') }}</h3>

        @if (!authService.isReadOnly && routes?.length) {
          <xi-fab
            icon="fab_plus"
            color="orca"
            buttonSize="normal"
            [tooltip]="{ text: t('create-route'), direction: 12 }"
            (onClick)="onAddRoute()"
          >
          </xi-fab>
        }
      </div>

      <div class="configuration-route-list__scroll">
        @if (routes?.length && !isLoading) {
          <div>
            <xi-list
              select="single"
              size="large"
              [hasSearch]="false"
              [hasDragging]="false"
              [hasBorder]="false"
              [value]="selectedRoute"
            >
              <div slot="children">
                @for (route of routes; track route) {
                  <div>
                    <xi-list-item
                      [checked]="selectedRoute === route"
                      [attr.id]="route.route_id"
                      [value]="route.route_id"
                      (onItemClick)="onRouteSelected(route, $event)"
                      [class.kxi-text-600]="selectedRoute === route"
                    >
                      <div slot="children" class="configuration-route-list__content">
                        <div *appMiddleEllipsize="route.name"></div>
                        <div class="configuration-route-list__language-translation-container">
                          <div
                            class="configuration-route-list__language-translation-item"
                            [matTooltip]="t('default-language')"
                          >
                            <xi-icon icon="star_filled" iconSize="small"></xi-icon>
                            <span>: {{ getLanguageText(route.default_language_id) }}</span>
                          </div>
                          <div
                            class="configuration-route-list__language-translation-item"
                            [matTooltip]="t('machine-language')"
                          >
                            <xi-icon icon="translation_filled" iconSize="small"></xi-icon>
                            <span
                              >: {{ getLanguageText(route.translation_target_language_id) }}</span
                            >
                          </div>
                        </div>
                      </div>
                    </xi-list-item>
                  </div>
                }
              </div>
            </xi-list>
          </div>
        }
        @if (!routes?.length && !isLoading) {
          <app-empty-side-panel
            emptyViewText="{{ t('empty-text') }}"
            emptyViewTitle="{{ t('empty-title') }}"
            ctaButtonText="{{ t('empty-cta-btn-text') }}"
            (ctaButtonClick)="onAddRoute()"
          ></app-empty-side-panel>
        }
      </div>
    </div>
  </div>
</ng-template>

<ng-template #rightSide>
  <div side="right">
    <router-outlet></router-outlet>
  </div>
</ng-template>

@if (showCreateConfigurationRoute) {
  <app-create-configuration-route-drawer
    [groupId]="createConfigurationRouteData.groupId"
    [nameValidator]="createConfigurationRouteData.nameValidator"
    [open]="showCreateConfigurationRoute"
    (close)="onCreateConfigurationRouteClosed($event)"
    [canEditRoute]="canEditRoute"
  >
  </app-create-configuration-route-drawer>
}
